import { React } from 'Imports';
import { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import TrimbleMaps = require('@trimblemaps/trimblemaps-js');
import '@trimblemaps/trimblemaps-js/trimblemaps.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import { IConfigServiceInjectedProps, ConfigService } from '$State/ConfigFreezerService';

const styles = require('./EventLocationMap.scss') as {
    mapContainer: string;
    map: string;
    mapUnavailable: string;
};

interface EventLocationMapProps {
    latitude: number;
    longitude: number;
}

const _EventLocationMap = (props: EventLocationMapProps & IConfigServiceInjectedProps) => {
    const mapContainerRef = useRef(null);
    const trimbleMapsAPIKey = props.config.getTrimbleMapsAPIKey();

    useEffect(() => {
        if (!trimbleMapsAPIKey) {
            return;
        }

        TrimbleMaps.APIKey = trimbleMapsAPIKey;

        const map = new TrimbleMaps.Map({
            container: mapContainerRef.current ?? '',
            center: [props.longitude, props.latitude],
            zoom: 10,
        });

        const navigationControl = new TrimbleMaps.NavigationControl({
            showZoom: true,
            showCompass: false,
        });

        map.addControl(navigationControl);

        // The container can still be mid-layout (e.g. right after a tab switch) when the map is
        // constructed, leaving its canvas sized 0x0 with nothing painted. Resizing once the map
        // reports itself loaded forces it to re-measure the container and draw.
        map.on('load', () => map.resize());

        const el = document.createElement('div');
        const root = createRoot(el);
        root.render(<FontAwesomeIcon color="#0d7ac5" fontSize={'30px'} icon={faLocationDot} />);

        new TrimbleMaps.Marker(el).setLngLat([props.longitude, props.latitude]).addTo(map);

        return () => {
            map?.remove();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [trimbleMapsAPIKey]);

    return (
        <div className={styles.mapContainer}>
            {trimbleMapsAPIKey ? (
                <div ref={mapContainerRef} className={styles.map}></div>
            ) : (
                <div className={styles.mapUnavailable}>Map currently unavailable</div>
            )}
        </div>
    );
};

export const EventLocationMap = ConfigService.inject(_EventLocationMap);
